/*
 * action types
 */
export const SET_OPEN_MODAL = 'SET_OPEN_MODAL'

/*
 * action creators
 */

export default function setOpenModal(payload) {
  return {
    payload,
    type: SET_OPEN_MODAL,
  }
}
